(function () {
    document.querySelectorAll('[data-pagination-trigger]').forEach(function (trigger) {
      const mode = trigger.dataset.mode;
      const sectionId = trigger.dataset.sectionId;
      const grid = trigger.parentElement.querySelector('[data-collection-grid]') ||
                   trigger.previousElementSibling;
      const button = trigger.querySelector('[data-load-more]');
      const label  = trigger.querySelector('[data-load-more-label]');
      const status = trigger.querySelector('[data-load-more-status]');
      let nextUrl = trigger.dataset.nextUrl;
      let loading = false;

      function fetchNext() {
        if (loading || !nextUrl) return;
        loading = true;
        if (button) button.setAttribute('data-state', 'loading');

        const url = nextUrl.indexOf('?') >= 0
          ? nextUrl + '&section_id=' + encodeURIComponent(sectionId)
          : nextUrl + '?section_id=' + encodeURIComponent(sectionId);

        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            const freshGrid = doc.querySelector('[data-collection-grid]');
            const freshTrigger = doc.querySelector('[data-pagination-trigger]');

            if (freshGrid && grid) {
              const cards = freshGrid.querySelectorAll('.card-product');
              cards.forEach(function (c) { grid.appendChild(c); });
            }

            if (freshTrigger) {
              nextUrl = freshTrigger.dataset.nextUrl;
              trigger.dataset.nextUrl = nextUrl;
            } else {
              nextUrl = '';
              trigger.style.display = 'none';
              if (status) status.textContent = 'That’s everything.';
            }
          })
          .catch(function () {
            if (status) status.textContent = 'Could not load more.';
          })
          .finally(function () {
            loading = false;
            if (button) button.removeAttribute('data-state');
          });
      }

      if (mode === 'load-more' && button) {
        button.addEventListener('click', fetchNext);
      }

      if (mode === 'infinite' && 'IntersectionObserver' in window) {
        if (button) button.style.display = 'none';
        const io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) fetchNext();
          });
        }, { rootMargin: '400px' });
        io.observe(trigger);
      }
    });
  })();
